import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { ArchiveService } from "../../services/archive/ArchiveService";
import UserContext, { User_Type } from "../UserContext";
import { ArchiveBlock } from "./ArchiveBlock";

export const Archive = () => {
    const theme = useTheme();
    const { user } = useContext(UserContext);

    return (
        <Box style={{ padding: theme.spacing(1) }}>
            <Typography variant="h4">Archive</Typography>
            <Divider />

            <ArchiveBlock
                getter={({
                    page,
                    limit,
                    org,
                }: {
                    page: number;
                    limit: number;
                    org: any;
                }) =>
                    ArchiveService.getUsers(
                        { page, limit },
                        org,
                        user?.user_type == User_Type.Admin
                            ? user.organization.apiKey[0].key
                            : undefined
                    )
                }
                onRestore={(item: any, org: any) =>
                    ArchiveService.restoreUser(item, org)
                }
                onDelete={(item: any, org) =>
                    ArchiveService.deleteUser(item, org)
                }
                ops={{
                    read: "READ USER",
                    restore: "READ USER",
                    delete: "READ USER",
                }}
                label="Users"
                accessor="name"
            />
        </Box>
    );
};
export default Archive;
